/**
 * Форматирование значений (даты, типы данных)
 * @TODO: рассмотреть перенос в @cdisoft-library
 */
export const typeFormat = function (value, type) {
    if (value === undefined || value === null)
        return ''
    let date;
    switch (type) {
        case "date":
            return value.toLocaleDateString();
        case "date-time-tm":
            return (value.getFullYear() + "-" +
                ("0" + (value.getMonth() + 1)).slice(-2) + "-" +
                ("0" + value.getDate()).slice(-2) + ' ' + value.toLocaleTimeString());
        case "date-time-gmt":
            date = new Date(value.getTime());
            date.setHours(date.getHours() + (new Date().getTimezoneOffset() / 60));
            return (date.toLocaleDateString() + ' ' + date.toLocaleTimeString());
        case "date-gmt":
            date = new Date(value.getTime());
            date.setHours(date.getHours() + (new Date().getTimezoneOffset() / 60));
            return (date.toLocaleDateString());
        case "time-gmt":
            date = new Date(value.getTime());
            date.setHours(date.getHours() + (new Date().getTimezoneOffset() / 60));
            return (date.toLocaleTimeString());
        case "date-time-chart":
            date = new Date(value.getTime());
            date.setHours(date.getHours() + (new Date().getTimezoneOffset() / 60));
            return (date.getFullYear() + "-" +
                ("0" + (date.getMonth() + 1)).slice(-2) + "-" +
                ("0" + date.getDate()).slice(-2) + ' ' + date.toLocaleTimeString());
        case "date-time":
            return (value.toLocaleDateString() + ' ' + value.toLocaleTimeString());
        case "time":
            return (value.toLocaleTimeString());
        case "timeHHMM":
            date = new Date(value.getTime());
            //date.setHours(date.getHours() + (new Date().getTimezoneOffset() / 60));
            return (("0" + (date.getHours())).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2));
        default:
            return value;
    }
};
export const dateFilter = function (value, filter) {
    if (
        filter === undefined ||
        filter === null ||
        (typeof filter === "string" && filter.trim() === "")
    ) {
        return true;
    }
    if (value === undefined || value === null) {
        return false;
    }
    return (
        typeFormat(value, "date-gmt") ===
        typeFormat(filter, "date")
    );
};
export const formatSqlDate = function (date, gmt) {
    if (date == null) return date;
    const newDate = new Date(date.getTime());
    if (!gmt)
        newDate.setHours(newDate.getHours() + (new Date().getTimezoneOffset() / 60));
    return newDate.getFullYear() + ("0" + (newDate.getMonth() + 1)).slice(-2) + ("0" + newDate.getDate()).slice(-2);
};
export const formatSqlDateTime = function (date, gmt) {
    if (date == null) return date;
    const newDate = new Date(date.getTime());
    if (!gmt)
        newDate.setHours(newDate.getHours() + (new Date().getTimezoneOffset() / 60));
    const pad = (n) => String(n).padStart(2, "0");
    return (
        date.getFullYear() +
        pad(date.getMonth() + 1) +
        pad(date.getDate()) +
        pad(date.getHours()) +
        pad(date.getMinutes()) +
        pad(date.getSeconds())
    );
    //return newDate == null ? null : newDate.getFullYear() + ("0" + (newDate.getMonth() + 1)).slice(-2) + ("0" + newDate.getDate()).slice(-2) + ("0" + newDate.getHours()).slice(-2) + ("0" + newDate.getMinutes()).slice(-2) + ("0" + newDate.getSeconds()).slice(-2)
};

/**
 * Утилита форматирования строк (замена String.prototype.format)
 * @param {string} str - строка с шаблоном {0}, {1} и т.д.
 * @param {...*} args - аргументы для подстановки
 * @returns {string}
 */
export const formatString = (str, ...args) => {
    return str.replace(/{(\d+)}/g, (match, number) =>
        typeof args[number] !== 'undefined' ? args[number] : match
    );
};

export const primeVueRU = {
    locale: {
        startsWith: 'Начинается с',
        contains: 'Содержит',
        notContains: 'Не содержит',
        endsWith: 'Заканчивается с',
        equals: 'Равно',
        notEquals: 'Не равно',
        noFilter: 'Без фильтра',
        lt: 'Меньше чем',
        lte: 'Меньше чем или рано',
        gt: 'Больше чем',
        gte: 'Больше чем или равно',
        dateIs: 'Date is',
        dateIsNot: 'Date is not',
        dateBefore: 'Date is before',
        dateAfter: 'Date is after',
        clear: 'Очистить',
        apply: 'Применить',
        matchAll: 'Match All',
        matchAny: 'Match Any',
        addRule: 'Добавить правило',
        removeRule: 'Удалить правило',
        accept: 'Да',
        reject: 'Нет',
        choose: 'Выбор',
        upload: 'Загрузка',
        cancel: 'Отказ',
        dayNames: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
        dayNamesShort: ["Вос", "Пон", "Вто", "Сре", "Чет", "Пят", "Суб"],
        dayNamesMin: ["ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"],
        monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
        monthNamesShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
        today: 'Сегодня',
        weekHeader: 'Wk',
        firstDayOfWeek: 0,
        dateFormat: 'mm/dd/yy',
        weak: 'Лёгкий',
        medium: 'Средний',
        strong: 'Сложный',
        passwordPrompt: 'Введите пароль',
        emptyFilterMessage: 'Результатов нет',
        emptyMessage: 'Нет доступных опций'
    }
}
export const crypted = function (value) {
    return value.split('').map((value, index) => value.charCodeAt(0) ^ (index + index - 1));
};
export const decrypted = function (array) {
    if (array === undefined || array === null) {
        return undefined;
    }
    if (typeof array === 'string') {
        array = array.split(',').map(Number);
    }
    if (!Array.isArray(array) || array.length === 0) {
        return undefined;
    }
    return array.map((value, index) => value ^ (index + index - 1)).map(value => String.fromCharCode(value)).join('');
};
export const lowerCaseLetter = (value) => (value.charAt(0).toLowerCase() + value.slice(1));
export const upperCaseLetter = (value) => (value.charAt(0).toUpperCase() + value.slice(1));
export const checkAuthenticated = () => {
    if (sessionStorage.session) {
        if (localStorage.login && localStorage.password) {
            return true;
        } else
            return false
    } else if (localStorage.login && localStorage.password && localStorage.checked == 'true') {
        return true;
    }
    return false
}